import { ButtonBase, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { DateObject } from "react-multi-date-picker";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { MelkMalekModel } from "../../Api/Models/MelkMalek";
import DashboardLayout from "../../Components/LayoutContainers/DashboardLayout";
import MDBox from "../../Components/MDBox";
import MDDate from "../../Components/MDDate";
import MDInput from "../../Components/MDInput";
import MDTypography from "../../Components/MDTypography";
import DashboardNavbar from "../../Components/Navbars/DashboardNavbar";
import { ErrorToaast } from "../../utils/toast/Toast";
import persian from "react-date-object/calendars/persian";
import MDButton from "../../Components/MDButton";
import { useFormik } from "formik";
import * as Yup from "yup";
import { AvarezNosaziModel } from "../../Api/Models/AvarezNosaziModel";
import { v4 as uuid } from "uuid";
import PrintIcon from "@mui/icons-material/Print";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteRow from "./components/dialogs/DeleteRow";
import SelectGheymat from "../GheymatManteghei/Components/SelectGheymat";
const validationSchema = Yup.object().shape({
  GheymatMantaghei: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  DarsadTakhfif: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  NoeKarbari: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  MetrajMaaber: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
});
const InputDetail = ({ input, ...others }: any) => {
  return (
    <MDBox mx="-6px" bgColor="#fefefe" borderRadius="4px" border="1px solid #757575" width="100%" {...others}>
      <MDTypography fontSize="14px" py={0.25} fontWeight="bold" color="dark">
        {input ?? ""}
      </MDTypography>
    </MDBox>
  );
};
export default function AvarezNosazi() {
  const { id } = useParams();
  const melkMalek = new MelkMalekModel();
  const avarezNosazi = new AvarezNosaziModel();
  const navigate = useNavigate();
  const [melkMalekData, setMelkMalekData] = useState<any | null>(null);
  const [printable, setPrintable] = useState(false);
  const date = new DateObject({ calendar: persian });
  const [counter, setCounter] = useState(0);
  const [deleteOpen, setDeleteOpen] = useState<{ open: boolean; id: number }>({ open: false, id: 0 });
  const [selectGheymat, setSelectGheymat] = useState({ open: false });
  useEffect(() => {
    melkMalek
      .get(parseInt(id ?? "0"))
      .then((r) => {
        setMelkMalekData(r.data.data);

        initFunction(r.data.data);
      })
      .catch((e) => {
        ErrorToaast("خطا در برقراری ارتباط");
        navigate("/", { replace: true });
      });
    return () => {};
  }, [counter]);

  const formik = useFormik({
    initialValues: {
      GheymatMantaghei: "",
      DarsadTakhfif: "0",
      NoeKarbari: "",
      MetrajMaaber: "",
      MablaghPasmand: "0",
      TozihBedehi: "",
      MablaghAvarez: "0",
      TedadSalBedehi: "0",
      TotalBedhiUntilNow: "0",
      TotalAll: "0",
    },
    validateOnChange: false,
    validateOnBlur: false,
    validateOnMount: false,
    validationSchema,

    onSubmit: (data: any) => {
      data.MelkMalekId = melkMalekData.id;
      avarezNosazi
        .SubmitData(data)
        .then((r) => {
          if (printable) {
            setPrintable(false);
            window.open(`/webroutes/Nosazi/${r.data.data.id}`, "_blank");
          }
          setCounter((c) => c + 1);
        })
        .catch((e) => ErrorToaast("خطا در برقراری ارتباط"));
    },
  });
  function handleChange() {
    let { GheymatMantaghei, MetrajMaaber, DarsadTakhfif } = formik.values;
    if (GheymatMantaghei !== "" && MetrajMaaber !== "" && DarsadTakhfif !== "") {
      let darsad = 100 - parseFloat(DarsadTakhfif) ?? 0;
      let count = ((parseFloat(GheymatMantaghei) ?? 0) * (parseFloat(MetrajMaaber) ?? 0) * 0.06 * darsad) / 100;
      console.log((parseFloat(GheymatMantaghei) ?? 0) * (parseFloat(MetrajMaaber) ?? 0));

      formik.setFieldValue("MablaghAvarez", count);
      formik.setFieldValue("MablaghPasmand", count / 2);
      formik.setFieldValue("TotalAll", (count / 2) * 3);
    }
  }
  const initFunction = (data: any[] | any) => {
    // data.forEach(r=>)
  };
  const handleSendPrint = async () => {
    await setPrintable(true);
    formik.submitForm();
  };
  const handleClickRows = (data: any) => {
    formik.setFieldValue("GheymatMantaghei", data.gheymat);
    formik.setFieldValue("MetrajMaaber", data.metrajMabar);
    setSelectGheymat((p) => ({ ...p, open: false }));
  };
  return (
    <DashboardLayout>
      <DashboardNavbar name={"صدور عوارض نوسازی"} />
      <MDBox>
        <Grid container columnGap={"5px"} wrap="nowrap">
          <Grid item xs={4}>
            <MDBox bgColor="#f8f8ff" borderRadius="5px" border={"0.8px #bababa solid"} py={2}>
              <MDTypography fontSize="16px" textAlign="center">
                مشخصات ملک و مالک
              </MDTypography>
              <MDBox pt={"1px"} bgColor="black" mb={3} />

              <Grid container alignItems={"center"} textAlign="center" rowGap={2}>
                <Grid item xs={5}>
                  <MDTypography fontSize="14px">شماره پرونده</MDTypography>
                </Grid>
                <Grid item xs={7}>
                  <InputDetail input={melkMalekData?.shomParvande} />
                </Grid>
                <Grid item xs={5}>
                  <MDTypography fontSize="14px">نام مالک</MDTypography>
                </Grid>
                <Grid item xs={7}>
                  <InputDetail input={melkMalekData?.malekName} />
                </Grid>
                <Grid item xs={5}>
                  <MDTypography fontSize="14px">نام خانوادگی</MDTypography>
                </Grid>
                <Grid item xs={7}>
                  <InputDetail input={melkMalekData?.familyName} />
                </Grid>
                <Grid item xs={5}>
                  <MDTypography fontSize="14px">منطقه</MDTypography>
                </Grid>
                <Grid item xs={7}>
                  <InputDetail input={melkMalekData?.mantaghe} />
                </Grid>
                <Grid item xs={5}>
                  <MDTypography fontSize="14px">حوزه</MDTypography>
                </Grid>
                <Grid item xs={7}>
                  <InputDetail input={melkMalekData?.hoze} />
                </Grid>
                <Grid item xs={5}>
                  <MDTypography fontSize="14px">بلوک</MDTypography>
                </Grid>
                <Grid item xs={7}>
                  <InputDetail input={melkMalekData?.blook} />
                </Grid>
                <Grid item xs={5}>
                  <MDTypography fontSize="14px">کد ملک</MDTypography>
                </Grid>
                <Grid item xs={7}>
                  <InputDetail input={melkMalekData?.codeMelk} />
                </Grid>
                <Grid item xs={5}>
                  <MDTypography fontSize="14px">نوع ملک</MDTypography>
                </Grid>
                <Grid item xs={7}>
                  <InputDetail input={melkMalekData?.melkKind} />
                </Grid>
                <Grid item xs={5}>
                  <MDTypography fontSize="14px">وضعیت ملک</MDTypography>
                </Grid>
                <Grid item xs={7}>
                  <InputDetail input={melkMalekData?.melkStatus} />
                </Grid>
                <Grid item xs={5}>
                  <MDTypography fontSize="14px">مساحت زمین</MDTypography>
                </Grid>
                <Grid item xs={7}>
                  <InputDetail input={melkMalekData?.masZamin} />
                </Grid>
                <Grid item xs={5}>
                  <MDTypography fontSize="14px">مساحت بنا</MDTypography>
                </Grid>
                <Grid item xs={7}>
                  <InputDetail input={melkMalekData?.mazBana} />
                </Grid>
                <Grid item xs={5}>
                  <MDTypography fontSize="14px">تعداد طبقات</MDTypography>
                </Grid>
                <Grid item xs={7}>
                  <InputDetail input={melkMalekData?.totalFloor} />
                </Grid>
              </Grid>
            </MDBox>
          </Grid>
          <Grid item xs={8} mb={4}>
            <MDBox bgColor="#f8f8ff" borderRadius="5px" border={"0.8px #bababa solid"} component="form" role="form" onSubmit={formik.handleSubmit}>
              <MDTypography fontSize="16px" textAlign="center" py={1}>
                صدور فیش
              </MDTypography>
              <MDBox pt={"1px"} bgColor="black" mb={3} />
              <Grid container alignItems={"center"} textAlign="center" rowGap={2} px={"12px"}>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">تاریخ آخرین فیش</MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <InputDetail
                    mx={0}
                    input={
                      melkMalekData?.avarezNosazis.length > 0
                        ? melkMalekData?.avarezNosazis[melkMalekData?.avarezNosazis.length - 1]?.created
                        : "----"
                    }
                  />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">تاریخ فیش جدید</MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <MDBox bgColor="white">
                    <MDDate
                      name={"DateEnd"}
                      // onChange={(e: any) => formikChild.setFieldValue("ExpireDate", e)}
                      portal
                      label={""}
                      defaultValue={date.format("YYYY-MM-DD")}
                      error={false}
                      size="small"
                      disabled
                      onChange={() => {}}
                      helperText={""}
                    />
                  </MDBox>
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px" sx={{ color: formik.errors.GheymatMantaghei ? "red" : "" }}>
                    قیمت منطقه
                  </MDTypography>
                </Grid>
                <Grid item xs={4} onClick={() => setSelectGheymat((p) => ({ ...p, open: true }))}>
                  <MDInput
                    sx={{ background: "white" }}
                    fullWidth
                    size="small"
                    name="GheymatMantaghei"
                    value={formik.values.GheymatMantaghei}
                    autoComplete="off"
                  />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px" sx={{ color: formik.errors.MetrajMaaber ? "red" : "" }}>
                    متراژ معبر
                  </MDTypography>
                </Grid>
                <Grid item xs={4} onClick={() => setSelectGheymat((p) => ({ ...p, open: true }))}>
                  <MDInput
                    sx={{ background: "white" }}
                    fullWidth
                    size="small"
                    name="MetrajMaaber"
                    value={formik.values.MetrajMaaber}
                    autoComplete="off"
                  />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px" sx={{ color: formik.errors.NoeKarbari ? "red" : "" }}>
                    نوع کاربری
                  </MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <MDInput
                    sx={{ background: "white" }}
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="NoeKarbari"
                    value={formik.values.NoeKarbari}
                  />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px" sx={{ color: formik.errors.DarsadTakhfif ? "red" : "" }}>
                    درصد تخفیف
                  </MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <MDInput
                    sx={{ background: "white" }}
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="DarsadTakhfif"
                    value={formik.values.DarsadTakhfif}
                  />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px" sx={{ color: formik.errors.MablaghAvarez ? "red" : "" }}>
                    مبلغ سال جاری
                  </MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <MDInput
                    disabled
                    fullWidth
                    size="small"
                    name="MablaghAvarez"
                    value={formik.values.MablaghAvarez}
                    // error={formik.touched.ShMobile && Boolean(formik.errors.ShMobile)}
                  />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">مبلغ پسماند</MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <MDInput
                    sx={{ background: "white" }}
                    disabled
                    fullWidth
                    size="small"
                    // onChange={formik.handleChange}
                    value={formik.values.MablaghPasmand}
                    name="MablaghPasmand"
                  />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">تعداد سال بدهی</MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <MDInput
                    disabled
                    sx={{ background: "white" }}
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    value={formik.values.TedadSalBedehi}
                  />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">جمع بدهی تا سال جاری</MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <MDInput
                    disabled
                    sx={{ background: "white" }}
                    fullWidth
                    size="small"
                    // onChange={formik.handleChange}
                    value={formik.values.TotalBedhiUntilNow}
                    // error={formik.touched.ShMobile && Boolean(formik.errors.ShMobile)}
                  />
                </Grid>

                <Grid item xs={2}>
                  <MDTypography fontSize="14px">توضیحات بدهی</MDTypography>
                </Grid>
                <Grid item xs={10}>
                  <MDInput
                    sx={{ background: "white" }}
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="TozihBedehi"
                    value={formik.values.TozihBedehi}
                    // error={formik.touched.ShMobile && Boolean(formik.errors.ShMobile)}
                  />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">جمع کل</MDTypography>
                </Grid>
                <Grid item xs={10}>
                  <MDInput disabled sx={{ background: "white" }} fullWidth size="small" value={formik.values.TotalAll} />
                </Grid>
                <Grid container item p={2} columns={10} gap={2} wrap="nowrap">
                  <Grid item xs={2}>
                    <MDButton fullWidth width="100%" variant="outlined" color="success" onClick={handleChange}>
                      محاسبه
                    </MDButton>
                  </Grid>
                  <Grid item xs={2}>
                    <MDButton fullWidth width="100%" variant="outlined" color="primary" onClick={formik.resetForm}>
                      جدید
                    </MDButton>
                  </Grid>
                  <Grid item xs={2}>
                    <MDButton fullWidth width="100%" variant="outlined" color="secondary" type="submit">
                      ثبت
                    </MDButton>
                  </Grid>
                  <Grid item xs={2}>
                    <MDButton
                      fullWidth
                      width="100%"
                      variant="outlined"
                      color="info"
                      onClick={() => {
                        handleSendPrint();
                      }}
                    >
                      ثبت و چاپ
                    </MDButton>
                  </Grid>
                  <Grid item xs={2}>
                    <MDButton
                      fullWidth
                      width="100%"
                      variant="outlined"
                      color="error"
                      onClick={() => window.open(`/webroutes/AllNosazi/${id}`, "_blank")}
                    >
                      گزارش
                    </MDButton>
                  </Grid>
                </Grid>
              </Grid>
              <MDBox minHeight="40vh" maxHeight="40vh" sx={{ overflow: "auto" }} bgColor="#adaabb" border="1px solid #535353">
                <MDBox bgColor="#eeeeee" px={1}>
                  <Grid container gap="0 10px" columns={13} textAlign="center" wrap="nowrap" width={"100%"} overflow={"auto"}>
                    <Grid item xs={1} minWidth={"max-content"}>
                      <MDTypography fontSize={"14px"}>شماره فیش</MDTypography>
                    </Grid>
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>تاریخ</MDTypography>
                    </Grid>

                    <Grid item xs={2}>
                      <MDTypography fontSize={"14px"}>قیمت پسماند</MDTypography>
                    </Grid>
                    <Grid item xs={2}>
                      <MDTypography fontSize={"14px"}>قیمت عوارض</MDTypography>
                    </Grid>
                    <Grid item xs={2}>
                      <MDTypography fontSize={"14px"}>جمع کل</MDTypography>
                    </Grid>
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>پرداخت</MDTypography>
                    </Grid>
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>وضعیت</MDTypography>
                    </Grid>
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>حذف</MDTypography>
                    </Grid>
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>چاپ</MDTypography>
                    </Grid>
                  </Grid>
                </MDBox>
                {melkMalekData?.avarezNosazis?.length > 0 &&
                  melkMalekData.avarezNosazis.map((data: any, index: number) => {
                    return (
                      <MDBox
                        bgColor={index % 2 === 0 ? "#fbfbfb" : "white"}
                        px={1}
                        key={uuid()}
                        onClick={() => {
                          // handleRowClick(data);
                          // setEditable(data.id);
                        }}
                        sx={{ ":hover": { background: "#9185c8" }, cursor: "pointer" }}
                      >
                        <Grid container columns={13} textAlign="center" gap="0 10px" wrap="nowrap">
                          <Grid item xs={1}>
                            <MDTypography fontSize={"14px"}>{index + 1}</MDTypography>
                          </Grid>
                          <Grid item xs={1}>
                            <MDTypography fontSize={"14px"}>{data?.created}</MDTypography>
                          </Grid>
                          <Grid item xs={2}>
                            <MDTypography fontSize={"14px"}>{(parseFloat(data.mablaghAvarez) / 3).toFixed(2)}</MDTypography>
                          </Grid>
                          <Grid item xs={2}>
                            <MDTypography fontSize={"14px"}>{((parseFloat(data.mablaghAvarez) / 3) * 2).toFixed(2)}</MDTypography>
                          </Grid>
                          <Grid item xs={2}>
                            <MDTypography fontSize={"14px"}>{parseFloat(data.mablaghAvarez).toFixed(2)}</MDTypography>
                          </Grid>
                          <Grid item xs={1}>
                            <MDTypography fontSize={"14px"}>پرداخت شده</MDTypography>
                          </Grid>
                          <Grid item xs={1}>
                            <MDTypography fontSize={"14px"}>پرداخت شده</MDTypography>
                          </Grid>
                          <Grid item xs={1} alignSelf="center">
                            <MDBox onClick={() => setDeleteOpen({ open: true, id: data.id })}>
                              <DeleteIcon color="error" />
                            </MDBox>
                          </Grid>
                          <Grid item xs={1} alignSelf="center">
                            <MDBox onClick={() => window.open(`/webroutes/Nosazi/${data.id}`, "_blank")}>
                              <PrintIcon color="warning" />
                            </MDBox>
                          </Grid>
                        </Grid>
                      </MDBox>
                    );
                  })}
              </MDBox>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <DeleteRow
        open={deleteOpen.open}
        id={deleteOpen.id}
        setClose={() => setDeleteOpen({ id: 0, open: false })}
        onDone={() => {
          setDeleteOpen({ open: false, id: 0 });
          setCounter((c) => c + 1);
        }}
      />
      <SelectGheymat
        open={selectGheymat.open}
        setClose={() => {
          setSelectGheymat((p: any) => ({ ...p, open: false }));
        }}
        handleClick={(data: any) => handleClickRows(data)}
        onDone={undefined}
      />
    </DashboardLayout>
  );
}
